import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { Edit } from '@mui/icons-material';

const SelectContainer = styled.div`
display: flex;
flex-direction: column;
grid-row-gap: 4px;
label{
  font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #7E8A90;
}
`;
const Container = styled.div`
  border-radius: 4px;
  border: 1px solid #eee;
  cursor: pointer;
  span.css-1u9des2-indicatorSeparator {
    display: none;
}
div#react-select-2-listbox {
    overflow: auto !important;
    height: 100%;
    min-height: 90px;
    max-height: 200px;
    width: 100%;
    padding-right: 11px;
}
}
.css-1xc3v61-indicatorContainer .css-tj5bde-Svg {
    color: #1565D8 !important;
    stroke: #1565D8 !important;
    fill: #1565D8 !important;
}
svg.css-tj5bde-Svg {
    color: #1565D8 !important;
    stroke: #1565D8 !important;
    fill: #1565D8 !important;
}
div#react-select-2-placeholder {
    font-size: 14px;
    color: #808183;
}
.css-1dimb5e-singleValue {
  font-size: 14px;
  color: #808183;
}
.button-wrapper{
  margin: 4px 32px;
}
.css-vb0ibs-control {
    min-height: 32px !important;
    height: 32px;
}
.css-78j4l0-control {
    height: 32px;
    min-height: 32px;
}
`;
const AddressOption = styled.div`
  padding: 4px 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  cursor: pointer;
  font-size: 10px;
  color: ${({ isSelected }) => (isSelected ? '#1565D8' : '#4E5969')};
  background-color: ${({ isSelected }) => (isSelected ? '#f5f5f5' : 'white')};
  grid-gap: 8px;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  align-items: baseline;
  svg {
    font-size: 12px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

const EditIcon = styled(Edit)`
  color: #1565D8;
  width: 8px;
  height: 8px;
  cursor: pointer;
`;

const AddNewButton = styled.div`
  color: #1565D8;
  font-weight: 500;
  max-width: 127px;
  border-radius: 4px;
  padding: 6px 12px;
  margin: auto;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  margin: auto;
  gap: 8px;
  border:1px solid #1565D8;

  &:hover {
    background: #f8f9fa;
  }
`;

const customStyles = {
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none'
    }
  }),
  option: (base, state) => ({
    ...base,
  }),
  menu: (base) => ({
    ...base,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    border: '1px solid #eee'
  })
};

export const AddressSelector = ({
  addresses,
  selectedAddress,
  onAddressChange,
  onAddNewClick,
  onEditClick,
  label,
  optionButtonText,
  placeholder = "Select an address"
}) => {
  const CustomOption = ({ innerProps, label, data, isSelected }) => {
    if (data.isAddNew) {
      return (
        <div className='d-flex button-wrapper justify-content-center'>
        <AddNewButton {...innerProps}>
          {optionButtonText}
        </AddNewButton>
        </div>
      );
    }
    return (
      <AddressOption isSelected={isSelected} {...innerProps}>
        {label}
        <EditIcon onClick={() => onEditClick(data)} />
      </AddressOption>
    );
  };

  const options = [
    ...addresses,
    { value: 'add-new', label: 'Add New Address', isAddNew: true }
  ];

  return (
    <SelectContainer>
      <label>{label}</label>
    <Container>
      <Select
        options={options}
        styles={customStyles}
        components={{ Option: CustomOption }}
        value={selectedAddress}
        onChange={(option) => {
          if (option?.isAddNew) {
            onAddNewClick();
            return;
          }
          onAddressChange(option);
        }}
        isSearchable={true}
        placeholder={placeholder}
      />
    </Container>
    </SelectContainer>
  );
};